// Layout height constants in pixels
// These should be used consistently across components that need to account for layout offsets

export const HEADER_HEIGHT = 64;
export const DESKTOP_TITLEBAR_HEIGHT = 38;
export const OFFLINE_BANNER_HEIGHT = 48;
export const LAYOUT_GAP = 4;
